import React from "react";
import { Link } from "react-router-dom";

export const ChatAiTerms = () => {
  return (
    <div id="chat-ai-terms">
      <header className="chat-ai-terms-page-header">
        <div className="container">
          <h1>AI chat terms of use</h1>
          <p className="chat-ai-terms-updated">Last updated: April 22, 2026</p>
        </div>
      </header>

      <div className="translations-content-container">
        <div className="container">
          <div className="tab-content translations-content-item en visible" id="en">
            <p>
              These terms apply when you use the AI chat feature in this web application. By using
              AI chat, you agree to these terms in addition to any other terms that apply to the site
              or service as a whole.
            </p>

            <h2>Nature of the service</h2>
            <p>
              AI chat provides automated, informational responses. It is provided for convenience
              only. We may change, suspend, or discontinue the feature at any time without notice.
            </p>

            <h2>No warranty</h2>
            <p>
              AI chat and all outputs are provided &quot;as is&quot; and &quot;as available&quot;
              without warranties of any kind, whether express or implied, including implied
              warranties of merchantability, fitness for a particular purpose, or non-infringement,
              to the fullest extent permitted by law.
            </p>

            <h2>Accuracy and mistakes</h2>
            <p>
              Artificial intelligence can be wrong, incomplete, or misleading. You are responsible
              for how you use responses. Do not rely on AI chat for decisions where errors could
              cause harm or loss; verify important facts independently.
            </p>

            <h2>Not professional advice</h2>
            <p>
              AI chat does not create a professional relationship and is not a substitute for
              legal, medical, financial, or other qualified advice. Always consult a professional
              when appropriate.
            </p>

            <h2>Your conduct</h2>
            <p>You agree not to use AI chat to:</p>
            <ul>
              <li>
                <p>Violate any law or regulation, or infringe others&apos; rights.</p>
              </li>
              <li>
                <p>
                  Generate or solicit content that is unlawful, defamatory, harassing, hateful,
                  discriminatory, or that exploits or harms minors.
                </p>
              </li>
              <li>
                <p>
                  Attempt to probe, disrupt, or overload our systems, or to extract training data or
                  model internals in ways not intended by the product.
                </p>
              </li>
              <li>
                <p>
                  Submit sensitive personal data (for example health information, government
                  identifiers, or financial account details) unless you have confirmed that doing so
                  is appropriate and permitted under applicable law and our privacy notice.
                </p>
              </li>
            </ul>

            <h2>Our intellectual property</h2>
            <p>
              The application, branding, and underlying software remain our property or that of our
              licensors. Subject to these terms, we grant you a limited, non-exclusive,
              non-transferable right to use AI chat as offered through this website.
            </p>

            <h2>Third-party AI</h2>
            <p>
              Responses may be produced using third-party models or infrastructure. Those providers
              may process prompts and context as described in their own terms and policies. We are
              not responsible for third-party services we do not control.
            </p>

            <h2>Limitation of liability</h2>
            <p>
              To the fullest extent permitted by applicable law, we and our affiliates, officers,
              directors, employees, and suppliers will not be liable for any indirect, incidental,
              special, consequential, or punitive damages, or for loss of profits, data, or
              goodwill, arising from or related to your use of AI chat, even if we have been advised
              of the possibility of such damages. Our aggregate liability for any claim arising out
              of AI chat will not exceed the greater of (a) the amount you paid us specifically for
              AI chat in the twelve months before the claim, or (b) zero if no such fees apply.
            </p>

            <h2>Indemnity</h2>
            <p>
              You will defend and indemnify us against any claims, damages, losses, and expenses
              (including reasonable legal fees) arising from your use of AI chat or your violation
              of these terms, to the extent permitted by law.
            </p>

            <h2>Privacy</h2>
            <p>
              How we handle information in connection with AI chat is described in our{" "}
              <Link to="/chat-ai-privacy">AI chat privacy notice</Link>. Please read it alongside
              these terms.
            </p>

            <h2>Changes</h2>
            <p>
              We may update these terms from time to time. We will adjust the &quot;Last
              updated&quot; date when we do. Your continued use of AI chat after changes become
              effective constitutes your acceptance of the revised terms, where allowed by law.
            </p>

            <h2>Contact</h2>
            <p>
              For questions about these AI chat terms, use the same contact channels as for general
              inquiries about this website.
            </p>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="container" />
      </div>
    </div>
  );
};
